import React, { useState, useEffect } from 'react';
import { useSharedDataContext } from '../SharedDataContext';
import MaskedInput from 'react-text-mask';
import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import { isMobileNotValid, validateEmail, validatePan } from '../utility/utilityFunction';
import { centralCall } from '../../api';

const ProposerDetailsForm = ({ BtnVal, getOwnerDetailsObj }) => {

    const { sharedData, setSharedData } = useSharedDataContext();
    const [ErrorMSG, setErrorMSG] = useState({});
    const [stateCityObj, setStateCityObj] = useState({ State: "", City: "" });
    const [proposerDetails, setProposerDetails] = useState({
        ProposerGender: "M",
        FullName: "",
        EmailID:"",
        DOB: "",
        MobileNo: "",
        PanNumber: "",
        Address1: "",
        Address2: "",
        Address3: "",
        Pincode: ""
    });


    const eighteenYearsAgo = dayjs().subtract(18, 'year');

    // Function to disable dates after 18 years ago
    const disabledDate = (current) => {
        // Convert the current date to dayjs object
        const currentDayjs = dayjs(current);
        // Compare the current date with 18 years ago
        return currentDayjs.isAfter(eighteenYearsAgo, 'day');
    };

    const handleDOBChange = (date) => {
        if (date) {
            setProposerDetails({ ...proposerDetails, DOB: date.format('YYYY-MM-DD') });
        } else {
            setProposerDetails({ ...proposerDetails, DOB: "" });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProposerDetails({ ...proposerDetails, [name]: value });

        if (name === "Pincode" && value.length === 6) {
            centralCall({ URL: `/api/Binding/GetStateCityListByPincode?pincode=${value}` }).then(res => {
                if (res.data.StatusCode == "200") {
                    const data = res.data.Data[0];
                    setSharedData(prev=>({ ...prev, stateName: data.State, cityName: data.City }));
                    if (data) { setErrorMSG({ ...ErrorMSG, Pincode: "" }); }
                }
            });

        } else if(name === "Pincode" && value.length !== 6 ) {
            setSharedData(prev=>({ ...prev, stateName: "", cityName: "" }));
        }
    }

    useEffect(() => {
        if (sharedData.ownerDetailsObj) {
            const { OwnerName, ProposerGender, DOB, EmailID, MobileNo, Address1, Address2, Address3, Pincode, City, State, PanNumber } = sharedData.ownerDetailsObj;
            setProposerDetails({
                ...proposerDetails, FullName: OwnerName,
                ProposerGender,
                DOB,
                EmailID,
                MobileNo,
                Address1,
                Address2,
                Address3,
                Pincode,
                City,
                State,
                PanNumber,
            });
        } else {
            setProposerDetails({ ...proposerDetails, FullName: sharedData.ownername, MobileNo: sharedData.mobileno, Pincode: sharedData.pincode, City: sharedData.cityName, State: sharedData.stateName });
        }
    }, [sharedData?.ownerDetailsObj]);

    useEffect(() => {
        setStateCityObj({ ...stateCityObj, State: sharedData?.stateName, City: sharedData.cityName });
    }, [sharedData.cityName, sharedData.stateName]);


    const submitProposerForm = () => {
        const { ProposerGender, FullName, DOB, EmailID, MobileNo, Pincode, PanNumber, Address1, Address2, Address3 } = proposerDetails;
        const { City, State } = stateCityObj;
        let ErrorMSG = {};
        let goto = true;
        if (!ProposerGender) {
            ErrorMSG["ProposerGender"] = "Please choose proposer gender";
            goto = false;
        }
        if (!FullName.trim()) {
            ErrorMSG["FullName"] = "Please enter owner name";
            goto = false;
        }
        if (!DOB) {
            ErrorMSG["DOB"] = "Please choose your DOB";
            goto = false;
        }
        if (!EmailID) {
            ErrorMSG["EmailID"] = "Please enter your email ID";
            goto = false;
        } else if (!validateEmail(EmailID)) {
            ErrorMSG["EmailID"] = "Please enter valid email ID";
            goto = false;
        }
        if (!MobileNo) {
            ErrorMSG["MobileNo"] = "Please enter your mobile number";
            goto = false;
        } else if (MobileNo.length !== 10 || isMobileNotValid(MobileNo)) {
            ErrorMSG["MobileNo"] = "Please enter valid mobile number";
            goto = false;
        }
        if (Address1 === "") {
            ErrorMSG["Address1"] = "Please enter your address line 1";
            goto = false;
        }
        if (Address2 === "") {
            ErrorMSG["Address2"] = "Please enter your address line 2";
            goto = false;
        }
        if (Pincode === "") {
            ErrorMSG["Pincode"] = "Please enter your PIN code";
            goto = false;
        } else if (Pincode.length !== 6) {
            ErrorMSG["Pincode"] = "Please enter valid PIN code";
            goto = false;
        }
        if (City === "") {
            ErrorMSG["City"] = "Please enter your city";
            goto = false;
        }
        if (State === "") {
            ErrorMSG["State"] = "Please select your state";
            goto = false;
        }
        if (!PanNumber) {
            ErrorMSG["PanNumber"] = "Please enter PAN Number";
            goto = false;
        } else if (!validatePan(PanNumber)) {
            ErrorMSG["PanNumber"] = "PAN Number is not valid";
            goto = false;
        }
            setErrorMSG(ErrorMSG);

        if (goto) {
            const ownerDetailsObj = {
                OwnerName: FullName,
                ProposerGender,
                DOB,
                EmailID,
                MobileNo,
                Address1: Address1,
                Address2: Address2,
                Address3: Address3,
                Pincode: Pincode,
                City: City,
                State: State,
                PanNumber
            }

            setSharedData(prev=>({ ...prev, ownerDetailsObj }));

            getOwnerDetailsObj(ownerDetailsObj);
        }
    }



    return (<>
        <section className="HealthProUpdFormBoxSection">
            <div className="row">
                <div className="col-md-12 PetInput">
                    <label className="labeltext">Gender</label>
                    <div className="form-check-inline">
                        <label className="HLT_P_T_Box">
                            <input type="radio" name="ProposerGender" value="M" checked={proposerDetails.ProposerGender === "M"} onChange={handleChange} />
                            <span className="checkHLT_P_T_Box"></span>Male
                        </label>
                        <label className="HLT_P_T_Box">
                            <input type="radio" name="ProposerGender" value="F" checked={proposerDetails.ProposerGender === "F"} onChange={handleChange} />
                            <span className="checkHLT_P_T_Box"></span>Female
                        </label>
                    </div>
                    <span className="Error">{ErrorMSG["ProposerGender"]}</span>
                </div>
            </div>
            <div className="SameForm">
                <div className="row">
                    <div className="col-md-6">
                        <div className="PetInput">
                            <MaskedInput
                                mask={[/[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[\sa-zA-Z]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/, /[a-zA-Z\s]/]}
                                guide={false} showMask={false}
                                type="text" placeholder=" "
                                onChange={handleChange}
                                id="ForUpfullname" className="InputBox" name="FullName" value={proposerDetails.FullName} />
                            <label htmlFor="ForUpfullname" className="floating_label">Full Name</label>
                            <span className="Error">{ErrorMSG["FullName"]}</span>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="PetInput">
                            <DatePicker id="ForUpdob" className="InputBox" getPopupContainer={(trigger) => trigger.parentNode}
                                placement="bottomLeft" disabledDate={disabledDate} value={proposerDetails.DOB ? dayjs(proposerDetails?.DOB) : null}
                                defaultPickerValue={!proposerDetails.DOB ? eighteenYearsAgo : dayjs(proposerDetails.DOB)} inputReadOnly={true} onChange={(date) => handleDOBChange(date)} format="DD-MM-YYYY" />
                            <label htmlFor="ForUpdob">Date of Birth</label>
                            <span className="Error">{ErrorMSG["DOB"]}</span>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="PetInput">
                            <input type="email" placeholder="" name="EmailID" value={proposerDetails.EmailID} onChange={handleChange} id="ForUpemail" className="InputBox" />
                            <label htmlFor="ForUpemail">Email Address</label>
                            <span className="Error">{ErrorMSG["EmailID"]}</span>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="PetInput">
                            <MaskedInput type="tel"
                                mask={[/[6-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                placeholder=" "
                                guide={false}
                                showMask={false}
                                onChange={(e) => handleChange(e)}
                                onBlur={handleChange}
                                id="ForUpmobile" className="InputBox" name="MobileNo" value={proposerDetails.MobileNo} />
                            <label htmlFor="ForUpmobile">Mobile Number</label>
                            <span className="Error">{ErrorMSG["MobileNo"]}</span>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="PetInput">
                            <MaskedInput placeholder=" "
                                mask={[
                                    /[a-zA-z]/,
                                    /[a-zA-z]/,
                                    /[a-zA-z]/,
                                    /[pP]/,
                                    /[a-zA-z]/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /[a-zA-Z]/,
                                ]}
                                guide={false}
                                showMask={false}
                                style={{ textTransform: "uppercase" }} onChange={handleChange} onBlur={handleChange} id="ForUpPan" name="PanNumber" className="InputBox" value={proposerDetails.PanNumber} />
                            <label htmlFor="ForUpPan">Pan Number</label>
                            <span className="Error">{ErrorMSG["PanNumber"]}</span>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <label className="labeltext">Address</label>
                    </div>

                    <div className="col-md-6">
                        <div className="PetInput">
                            <input type="text" placeholder=" " onChange={handleChange} id="ForUp5" className="InputBox" name="Address1" value={proposerDetails.Address1} />
                            <label htmlFor="ForUp5">Address Line 1</label>
                            <span className="Error">{ErrorMSG["Address1"]}</span>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="PetInput">
                            <input type="text" placeholder=" " onChange={handleChange} id="ForUp6" className="InputBox" name="Address2" value={proposerDetails.Address2} />
                            <label htmlFor="ForUp6">Address Line 2</label>
                            <span className="Error">{ErrorMSG["Address2"]}</span>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="PetInput">
                            <input type="text" placeholder=" " onChange={handleChange} id="ForUp7" className="InputBox" name="Address3" value={proposerDetails.Address3} />
                            <label htmlFor="ForUp7">Address Line 3</label>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="PetInput">
                            <MaskedInput type="tel"
                                mask={[/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                placeholder=" "
                                showMask={false}
                                guide={false}
                                onChange={handleChange} id="ForUp8" className="InputBox" name="Pincode" value={proposerDetails.Pincode} />
                            <label htmlFor="ForUp8">PIN Code</label>
                            <span className="Error">{ErrorMSG["Pincode"]}</span>
                            {stateCityObj.City && stateCityObj.State && < span className="city_state_name" > {stateCityObj.City}, {stateCityObj.State}</span>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="SameForm">
                <div className="row">
                    <div className="col-md-12 text-center my-2">
                        <button type="submit" onClick={() => submitProposerForm()} className="SMCBTN w-auto" >{BtnVal} <i className="fas fa-chevron-right"></i></button>
                    </div>
                </div>
            </div>
        </section>
    </>)
}

export default ProposerDetailsForm;